export default [{
    item: '全国',
    main: [{
            name: '中国石化',
            value: 31678260
        },
        {
            name: '中国石油',
            value: 14037365
        },
        {
            name: '其他油站',
            value: 20980659
        }
    ]
}, {
    item: '北京',
    main: [{
            name: '中国石化',
            value: 696657
        },
        {
            name: '中国石油',
            value: 199567
        },
        {
            name: '其他油站',
            value: 260977
        }
    ]
}, {
    item: '天津',
    main: [{
            name: '中国石化',
            value: 404838
        },
        {
            name: '中国石油',
            value: 171571
        },
        {
            name: '其他油站',
            value: 345310
        }
    ]
}, {
    item: '河北',
    main: [{
            name: '中国石化',
            value: 4104419
        },
        {
            name: '中国石油',
            value: 1810625
        },
        {
            name: '其他油站',
            value: 3847375
        }
    ]
}, {
    item: '山西',
    main: [{
            name: '中国石化',
            value: 1202475
        },
        {
            name: '中国石油',
            value: 745855
        },
        {
            name: '其他油站',
            value: 3032996
        }
    ]
}, {
    item: '河南',
    main: [{
            name: '中国石化',
            value: 3703108
        },
        {
            name: '中国石油',
            value: 1446032
        },
        {
            name: '其他油站',
            value: 2455660
        }
    ]
}, {
    item: '山东',
    main: [{
            name: '中国石化',
            value: 3147346
        },
        {
            name: '中国石油',
            value: 1219182
        },
        {
            name: '其他油站',
            value: 1779002
        }
    ]
}, {
    item: '上海',
    main: [{
            name: '中国石化',
            value: 1753567
        },
        {
            name: '中国石油',
            value: 333880
        },
        {
            name: '其他油站',
            value: 459744
        }
    ]
}, {
    item: '江苏',
    main: [{
            name: '中国石化',
            value: 2363277
        },
        {
            name: '中国石油',
            value: 511943
        },
        {
            name: '其他油站',
            value: 896110
        }
    ]
}, {
    item: '浙江',
    main: [{
            name: '中国石化',
            value: 727363
        },
        {
            name: '中国石油',
            value: 134567
        },
        {
            name: '其他油站',
            value: 164690
        }
    ]
}, {
    item: '福建',
    main: [{
            name: '中国石化',
            value: 151568
        },
        {
            name: '中国石油',
            value: 22139
        },
        {
            name: '其他油站',
            value: 51346
        }
    ]
}, {
    item: '安徽',
    main: [{
            name: '中国石化',
            value: 3433293
        },
        {
            name: '中国石油',
            value: 754694
        },
        {
            name: '其他油站',
            value: 1190781
        }
    ]
}, {
    item: '江西',
    main: [{
            name: '中国石化',
            value: 1690498
        },
        {
            name: '中国石油',
            value: 471153
        },
        {
            name: '其他油站',
            value: 822925
        }
    ]
}, {
    item: '湖北',
    main: [{
            name: '中国石化',
            value: 991109
        },
        {
            name: '中国石油',
            value: 291332
        },
        {
            name: '其他油站',
            value: 354094
        }
    ]
}, {
    item: '湖南',
    main: [{
            name: '中国石化',
            value: 454164
        },
        {
            name: '中国石油',
            value: 100429
        },
        {
            name: '其他油站',
            value: 150411
        }
    ]
}, {
    item: '广东',
    main: [{
            name: '中国石化',
            value: 654266
        },
        {
            name: '中国石油',
            value: 118840
        },
        {
            name: '其他油站',
            value: 116240
        }
    ]
}, {
    item: '广西',
    main: [{
            name: '中国石化',
            value: 678747
        },
        {
            name: '中国石油',
            value: 158811
        },
        {
            name: '其他油站',
            value: 282351
        }
    ]
}, {
    item: '贵州',
    main: [{
            name: '中国石化',
            value: 48722
        },
        {
            name: '中国石油',
            value: 16139
        },
        {
            name: '其他油站',
            value: 15654
        }
    ]
}, {
    item: '云南',
    main: [{
            name: '中国石化',
            value: 82619
        },
        {
            name: '中国石油',
            value: 42073
        },
        {
            name: '其他油站',
            value: 18632
        }
    ]
}, {
    item: '海南',
    main: [{
            name: '中国石化',
            value: 17733
        },
        {
            name: '中国石油',
            value: 2327
        },
        {
            name: '其他油站',
            value: 5565
        }
    ]
}, {
    item: '黑龙江',
    main: [{
            name: '中国石化',
            value: 838673
        },
        {
            name: '中国石油',
            value: 991606
        },
        {
            name: '其他油站',
            value: 934750
        }
    ]
}, {
    item: '吉林',
    main: [{
            name: '中国石化',
            value: 710475
        },
        {
            name: '中国石油',
            value: 713966
        },
        {
            name: '其他油站',
            value: 497796
        }
    ]
}, {
    item: '辽宁',
    main: [{
            name: '中国石化',
            value: 1364430
        },
        {
            name: '中国石油',
            value: 1302270
        },
        {
            name: '其他油站',
            value: 1497939
        }
    ]
}, {
    item: '陕西',
    main: [{
            name: '中国石化',
            value: 383298
        },
        {
            name: '中国石油',
            value: 514772
        },
        {
            name: '其他油站',
            value: 478204
        }
    ]
}, {
    item: '新疆',
    main: [{
            name: '中国石化',
            value: 7902
        },
        {
            name: '中国石油',
            value: 23279
        },
        {
            name: '其他油站',
            value: 9379
        }
    ]
}, {
    item: '内蒙古',
    main: [{
            name: '中国石化',
            value: 252714
        },
        {
            name: '中国石油',
            value: 231039
        },
        {
            name: '其他油站',
            value: 348741
        }
    ]
}, {
    item: '青海',
    main: [{
            name: '中国石化',
            value: 7353
        },
        {
            name: '中国石油',
            value: 47539
        },
        {
            name: '其他油站',
            value: 20143
        }
    ]
}, {
    item: '宁夏',
    main: [{
            name: '中国石化',
            value: 278016
        },
        {
            name: '中国石油',
            value: 432591
        },
        {
            name: '其他油站',
            value: 195851
        }
    ]
}, {
    item: '甘肃',
    main: [{
            name: '中国石化',
            value: 95041
        },
        {
            name: '中国石油',
            value: 234966
        },
        {
            name: '其他油站',
            value: 136044
        }
    ]
}, {
    item: '西藏',
    main: [{
            name: '中国石化',
            value: 225
        },
        {
            name: '中国石油',
            value: 194
        },
        {
            name: '其他油站',
            value: 126
        }
    ]
}, {
    item: '四川',
    main: [{
            name: '中国石化',
            value: 496927
        },
        {
            name: '中国石油',
            value: 421617
        },
        {
            name: '其他油站',
            value: 175725
        }
    ]
}, {
    item: '重庆',
    main: [{
            name: '中国石化',
            value: 937437
        },
        {
            name: '中国石油',
            value: 572367
        },
        {
            name: '其他油站',
            value: 436098
        }
    ]
}]